(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["shoppable-reels"] && !Shopify.designMode) return;
  try {
    
(function () {
  class ShoppableReels {
    constructor(section) {
      this.section     = section;
      this.track       = section.querySelector('.shoppable-reels__track');
      this.items       = Array.from(section.querySelectorAll('.shoppable-reel-item'));
      this.videos      = Array.from(section.querySelectorAll('.shoppable-reel-item__video[src]'));
      this.layout      = section.dataset.layout;
      this.pauseHover  = section.dataset.pauseHover === 'true';
      this.prevBtn     = section.querySelector('.shoppable-reels__nav--prev');
      this.nextBtn     = section.querySelector('.shoppable-reels__nav--next');
      this.dotsWrapper = section.querySelector('.shoppable-reels__dots');
      this.desktopCols = parseInt(section.dataset.desktopCols, 10) || 4;
      this.mobileCols  = parseInt(section.dataset.mobileCols, 10) || 2;

      this._bindEvents();
      this._setupIntersectionObserver();
      if (this.layout === 'carousel') this._setupCarousel();
    }

    _visibleCols() {
      return window.innerWidth < 750 ? this.mobileCols : this.desktopCols;
    }

    /* ── Intersection observer: play/pause based on viewport ── */
    _setupIntersectionObserver() {
      if (!('IntersectionObserver' in window)) {
        this.videos.forEach(v => this._play(v));
        return;
      }

      const sectionObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              this._playVisibleVideos();
            } else {
              this.videos.forEach(v => v.pause());
            }
          });
        },
        { threshold: 0.1 }
      );
      sectionObserver.observe(this.section);

      const videoObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach(entry => {
            const video = entry.target;
            if (entry.isIntersecting) {
              this._play(video);
            } else {
              video.pause();
            }
          });
        },
        { threshold: 0.3 }
      );
      this.videos.forEach(v => videoObserver.observe(v));
    }

    _play(video) {
      if (video.paused) {
        const p = video.play();
        if (p) p.catch(() => {});
      }
    }

    _playVisibleVideos() {
      this.videos.forEach(v => this._play(v));
    }

    /* ── Hover pause/resume ── */
    _bindEvents() {
      if (this.pauseHover) {
        this.items.forEach(item => {
          const video = item.querySelector('video');
          if (!video) return;
          item.addEventListener('mouseenter', () => video.pause());
          item.addEventListener('mouseleave', () => this._play(video));
        });
      }
    }

    /* ── Carousel ── */
    _setupCarousel() {
      if (!this.track || !this.prevBtn || !this.nextBtn) return;

      this._buildDots();
      this._updateNav();

      this.prevBtn.addEventListener('click', () => this._scroll(-1));
      this.nextBtn.addEventListener('click', () => this._scroll(1));

      this.track.addEventListener('scroll', () => {
        this._updateNav();
        this._updateDots();
      }, { passive: true });

      window.addEventListener('resize', () => {
        this._updateNav();
        this._updateDots();
      });
    }

    _buildDots() {
      if (!this.dotsWrapper) return;
      const count = this.items.length;
      this.dotsWrapper.innerHTML = '';
      for (let i = 0; i < count; i++) {
        const dot = document.createElement('button');
        dot.className = 'shoppable-reels__dot' + (i === 0 ? ' shoppable-reels__dot--active' : '');
        dot.setAttribute('aria-label', 'Go to item ' + (i + 1));
        dot.addEventListener('click', () => this._scrollToIndex(i));
        this.dotsWrapper.appendChild(dot);
      }
    }

    _scroll(direction) {
      const cols      = this._visibleCols();
      const itemWidth = this.items[0]?.offsetWidth || 0;
      const gap       = parseInt(getComputedStyle(this.track).gap, 10) || 0;
      this.track.scrollBy({ left: direction * (itemWidth + gap) * cols, behavior: 'smooth' });
    }

    _scrollToIndex(index) {
      const itemWidth = this.items[0]?.offsetWidth || 0;
      const gap       = parseInt(getComputedStyle(this.track).gap, 10) || 0;
      this.track.scrollTo({ left: index * (itemWidth + gap), behavior: 'smooth' });
    }

    _currentIndex() {
      const itemWidth = this.items[0]?.offsetWidth || 0;
      const gap       = parseInt(getComputedStyle(this.track).gap, 10) || 0;
      return Math.round(this.track.scrollLeft / (itemWidth + gap));
    }

    _updateNav() {
      if (!this.prevBtn || !this.nextBtn) return;
      const atStart = this.track.scrollLeft <= 4;
      const atEnd   = this.track.scrollLeft + this.track.offsetWidth >= this.track.scrollWidth - 4;
      this.prevBtn.disabled = atStart;
      this.nextBtn.disabled = atEnd;
    }

    _updateDots() {
      if (!this.dotsWrapper) return;
      const current = this._currentIndex();
      this.dotsWrapper.querySelectorAll('.shoppable-reels__dot').forEach((dot, i) => {
        dot.classList.toggle('shoppable-reels__dot--active', i === current);
      });
    }
  }

  function init() {
    document.querySelectorAll('.shoppable-reels').forEach(section => {
      if (!section.dataset.reelsInit) {
        section.dataset.reelsInit = '1';
        new ShoppableReels(section);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Shopify theme editor re-init */
  document.addEventListener('shopify:section:load', (e) => {
    const section = e.target.querySelector('.shoppable-reels');
    if (section) {
      delete section.dataset.reelsInit;
      new ShoppableReels(section);
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
